import { Box, Button, Modal, toast } from '@palmetto/palmetto-components';
import { useCallback } from 'react';

export const ApiKeyDisplayModal = ({
  apiKey,
  isOpen,
  handleClose,
}: {
  apiKey: string;
  isOpen: boolean;
  handleClose: () => void;
}) => {
  const handleCopyToClipboard = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      toast.success('API key copied to clipboard');
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      toast.error('Failed to copy to clipboard');
    }
  }, [apiKey]);

  return (
    <Modal isOpen={isOpen} ariaLabelledBy="apiKeyDisplayModal" onDismiss={handleClose}>
      <Modal.Header id="apiKeyDisplayModal" title="Webhook API Key" onDismiss={handleClose} />
      <Modal.Body background="secondary" childGap="lg">
        <Box childGap="md">
          <Box fontSize="sm" color="body-secondary">
            Your webhook has been created. Please save this API key now - it will not be shown again.
          </Box>
          <Box
            background="primary"
            padding="md"
            radius="md"
            style={{ wordBreak: 'break-all', fontFamily: 'monospace' }}
          >
            {apiKey}
          </Box>
          <Box fontSize="xs" color="body-secondary">
            This key will be sent in the <code>apiKey</code> header of webhook requests to your endpoint.
          </Box>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCopyToClipboard}>
          Copy to Clipboard
        </Button>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
